import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const ProtectedRoute = ({ children, roles }) => {
  // const token = localStorage.getItem("token");
  // const user = JSON.parse(localStorage.getItem("user"));

  // const [user, setUser] = useState(null);
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="pos-common-main">
      <div style={{display: "flex", justifyContent: "center", margin: "5%"}}>
        <img 
          src='/images/loader.gif'
          style={{width: "100%", maxWidth: "441px"}}
        />
      </div>
      </div>;
  }

  if (!user) {
    return <div className="pos-common-main">
      <h2 style={{ textAlign: "center", marginTop: "50px" }}>
        You are not authorised
      </h2>
      </div>;
  }

  if (!roles.includes(user.role.toString())) {
    return <div className="pos-common-main"><h2 style={{ textAlign: "center", marginTop: "50px" }}>
      Access denied
    </h2></div>;
  }

  // if (!user.company_id) {
  //   return <Navigate to="/company-setup" replace state={{ from: "protected-route" }} />;
  // }

  // if (company?.uses_store && !store_id) return <Navigate to="/store-setup" replace />;

  return <div className="pos-main">{children}</div>;
};

export default ProtectedRoute;